import { Link } from '@sentecacommerce-theme/lib'
import React, { useState } from 'react'
import styled from 'styled-components'
import { CharacterType } from '..'
import { Typography } from '../../Common'

type Props = {
  data: CharacterType
}

const Character = ({ data }: Props) => {
  const [isFocused, setIsFocused] = useState<boolean>(false)
  return (
    <Link href={data.url} passHref>
      <SlideContainer>
        <SlideWrapper
          onMouseEnter={() => setIsFocused(true)}
          onMouseLeave={() => setIsFocused(false)}
        >
          <SlideCircle />
          <CircleImageContainer>
            <CircleImage
              loading="lazy"
              isFocused={isFocused}
              src={data.image}
              alt={data.header || 'Hippoland'}
            />
          </CircleImageContainer>
          <BorderBottomCircle />
        </SlideWrapper>
        <Name>{data.header}</Name>
      </SlideContainer>
    </Link>
  )
}

const SlideContainer = styled.a.attrs({
  className: 'd-block',
})`
  position: relative;
  margin-top: -2rem;

  @media (min-width: ${({ theme }) => theme.breakpoints.md.min}) {
    margin-top: -3rem;
  }
`

const SlideWrapper = styled.div`
  width: 16rem;
  height: 19rem;
  position: relative;
  border-bottom-left-radius: 7.8rem;
  border-bottom-right-radius: 7.8rem;
  overflow: hidden;
  cursor: pointer;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoints.md.max}) {
    width: 11.7rem;
    height: 13.7rem;
  }
`

const SlideCircle = styled.div`
  width: 16rem;
  height: 16rem;
  border: 0.1rem solid ${({ theme }) => theme.palette.silverTree};
  border-radius: 50%;
  position: absolute;
  bottom: 0;
  left: 0;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoints.md.max}) {
    width: 11.7rem;
    height: 11.7rem;
  }
`

const CircleImageContainer = styled.div`
  width: 100%;
  height: 100%;
  border-bottom-left-radius: 50%;
  border-bottom-right-radius: 50%;
  position: absolute;
  bottom: -3.7rem;
  left: 0;
  border-bottom: 0.2rem solid ${({ theme }) => theme.palette.silverTree};
`

interface IsFocusable {
  isFocused: boolean
}

const CircleImage = styled.img<IsFocusable>`
  display: block;
  width: 100%;
  max-width: 100%;
  height: auto;
  border: 0;
  ${(props) =>
    props.isFocused &&
    `
  transform: translateY(-2rem);
  `}
  transition: transform 0.6s cubic-bezier(.4, 0, .2, 1);
`

const BorderBottomCircle = styled.div`
  position: absolute;
  width: 16rem;
  height: 16rem;
  border-bottom: 1px solid ${({ theme }) => theme.palette.silverTree};
  border-bottom-left-radius: 50%;
  border-bottom-right-radius: 50%;
  bottom: -1px;
  left: 0;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoints.md.max}) {
    width: 11.7rem;
    height: 11.7rem;
  }
`

const Name = styled(Typography).attrs({
  as: 'p',
  variant: 5,
  className: 'mt-2 mx-0 mb-0',
})`
  text-align: center;
  max-width: 16rem;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoints.sm.max}) {
    font-size: 1.3rem;
  }
`

export { Character }
